import React from 'react';
import MembersManagementPage from '../../members/MembersManagementPage';
import { ADMIN_COPY } from '../adminCopy';
import { AdminPageHeader } from '../ui';
import '../CompanyManagement.css';

export default function AdminMembersPage() {
  return (
    <MembersManagementPage
      copy={ADMIN_COPY.MEMBERS}
      badge={ADMIN_COPY.MEMBERS.BADGE}
      PageHeader={AdminPageHeader}
      rootClassName="adm-dash company-management-v2"
      shellClassName="co-shell adm-panel"
      createBtnClassName="co-create-btn"
      variant="admin"
    />
  );
}
